import { render, staticRenderFns } from "./pages404.vue?vue&type=template&id=07c0b487&scoped=true&"
import script from "./pages404.vue?vue&type=script&lang=js&"
export * from "./pages404.vue?vue&type=script&lang=js&"
import style0 from "./pages404.vue?vue&type=style&index=0&id=07c0b487&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c0b487",
  null
  
)

export default component.exports